import React from "react";
import SidebarAdList from "./SidebarAdList";

/**
 * MobileAdsStrip — renders creatives from the `sidebar` and `sidebar-bottom`
 * slots as a horizontal strip on mobile/tablet, where the desktop sidebar is
 * hidden. This ensures ads are always visible even when advertisers only
 * uploaded creatives to the sidebar slots.
 *
 * Renders nothing when there are no active creatives (no empty placeholders).
 */
export default function MobileAdsStrip({ category, articleId, className = "" }) {
  return (
    <div
      className={`lg:hidden ${className}`}
      data-testid="mobile-ads-strip"
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <SidebarAdList slot="sidebar" category={category} articleId={articleId} />
        <SidebarAdList slot="sidebar-bottom" category={category} articleId={articleId} />
      </div>
    </div>
  );
}
